import { Typography } from '@mui/material';
import { styled } from '@mui/system';

const RootDiv = styled('div')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  minHeight: '100vh',
});

const ErrorContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  height: 'fit-content',
  width: '600px',
});

const IconContainer = styled('div')({
  position: 'relative',
  width: '246px',
  height: '145px',
  marginBottom: '30px',
});

const MainTextContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  [theme.breakpoints.down(570)]: {
    padding: '0px 90px',
  },
}));

const TextTypography = styled(Typography)(({ theme }) => ({
  fontFamily: 'Poppins',
  fontWeight: 400,
  fontSize: '30px',
  lineHeight: '45px',
  textAlign: 'center',
  color: '#414046',
  [theme.breakpoints.down(570)]: {
    fontSize: '16px',
    lineHeight: '24px',
  },
}));

const LinkTypography = styled(Typography)(({ theme }) => ({
  fontFamily: 'Poppins',
  fontWeight: 400,
  fontSize: '16px',
  lineHeight: '24px',
  textAlign: 'center',
  color: '#0A7ABE',
  textDecoration: 'underline',
  cursor: 'pointer',
  [theme.breakpoints.down(570)]: {
    fontSize: '14px',
    lineHeight: '21px',
  },
}));

const SmallTypography = styled(Typography)(({ theme }) => ({
  fontFamily: 'Poppins',
  fontWeight: 300,
  fontSize: '16px',
  lineHeight: '24px',
  textAlign: 'center',
  color: '#414046',
  [theme.breakpoints.down(570)]: {
    fontSize: '14px',
    lineHeight: '21px',
  },
}));

const LinkContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  gap: '6px',
  marginTop: '40px',
  [theme.breakpoints.down(570)]: {
    flexDirection: 'column',
    gap: '0px',
  },
}));

export {
  RootDiv,
  ErrorContainer,
  IconContainer,
  TextTypography,
  LinkTypography,
  SmallTypography,
  LinkContainer,
  MainTextContainer,
};
